import { getConfig } from '../../config';
import { COUNTRY_DOMAINS } from '../constants';

export default function useCandidateUrl() {
  const config = getConfig();
  const domain = config?.COUNTRY ?? COUNTRY_DOMAINS.default;
  const candidateUrl =
    domain && domain !== COUNTRY_DOMAINS.default
      ? `${config.CANDIDATE_URL}/${domain}`
      : config.CANDIDATE_URL;

  return candidateUrl;
}
